'use client';

import { useAtomValue } from 'jotai';
import { usePathname, useSearchParams } from 'next/navigation';

import Pagination from '@gds/Pagination/Pagination';
import { PaginationItem } from '@gds/Pagination/PaginationItem';
import { shouldShowRegionLoaderAtom } from '@search/Atoms/RegionLoadingStateAtom';

import { buildPLPPaginationUrl } from '../BuildPLPPaginationUrl';
import type { PaginationProps } from './Pagination.entity';

export const DealersPagination = ({ currentPage, strings, totalPages }: PaginationProps) => {
  const pathname = usePathname();
  const queryParams = useSearchParams();
  const queryParamsString = queryParams.toString();
  const shouldShowLoader = useAtomValue(shouldShowRegionLoaderAtom);

  if (shouldShowLoader) {
    return null;
  }

  return (
    <Pagination
      currentPage={currentPage}
      data-test-id="dealers-pagination"
      locale={strings}
      totalPages={totalPages}
      renderItem={paginationItem => (
        <PaginationItem
          component="Link"
          href={buildPLPPaginationUrl(pathname, queryParamsString, paginationItem.page)}
          {...paginationItem}
        />
      )}
    />
  );
};
